import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {RouterLinks} from '../../constants';
import {NavigationEnd, Router} from '@angular/router';
import {ClaimStore} from 'src/app/modules/claim/state/state/claims-session.store';
import {FlowPlayerService} from '../../services/flow-player.service';
import {GlobalQuestionService} from '../../services/global-question.service';
import {ClaimGuardService} from '../../services/claim-guard.service';
import {QuestionFlowSessionQuery} from '../../questions/state/question-flow-session.query';
import {RequestCallComponent} from '../../../shared/components/request-call/request-call.component';
import { UserStore } from 'src/app/modules/authentication/state/user.store';

declare function notify(): any;
declare const Tawk_API: any;
declare const $: any;

@Component({
    selector: 'app-landing-left-sidebar',
    templateUrl: './landing-left-sidebar.component.html',
    styleUrls: ['./landing-left-sidebar.component.scss'],
    standalone: false
})
export class LandingLeftSidebarComponent implements OnInit, AfterViewInit {

  @Input() showDetails = false;
  @Input() hasNotice = false;
  @Output() detailsShown = new EventEmitter<any>();
  @ViewChild('requestCallComponent', {static: false}) requestCallComponent: RequestCallComponent;
  inProgress = environment.inProgress;
  notify: any;
  chat: any;
  current_route: any;
  RouterLinks = RouterLinks;
  moreActiveDesktop = false;
  moreActiveMobile = false;
  selectedDesktopIdx = 0;
  selectedIdx = 0;
  subMenu = false;
  referral = false;
  currentUser: any;
  constructor(
    private router: Router,
    private claimStore: ClaimStore,
    private userStore: UserStore,
    private flowPlayer: FlowPlayerService,
    public questionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private claimGuardService: ClaimGuardService,
  ) {
    this.current_route = this.router.url;
    this.currentUser = this.userStore.getValue();
  
    if (
      this.current_route.includes(RouterLinks.PolicyOverview) ||
      this.current_route.includes(RouterLinks.PolicySummary) ||
      this.current_route.includes(RouterLinks.PolicyInsuredItems) ||
      this.current_route.includes(RouterLinks.PolicyAddons) ||
      this.current_route.includes(RouterLinks.PolicyPayment) ||
      this.current_route.includes(RouterLinks.PolicyResources) 
      // this.current_route.includes(RouterLinks.PolicyDocuments)
      
    ) {
      this.subMenu = true;
    }
    if (
      this.current_route.includes(RouterLinks.Referrals) 
    ) {
      this.referral = true;
      
    }
    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationEnd) {
       
      }
    })
    
  }

  ngOnInit(): void {
   
  }
 
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.chat = Tawk_API;
      this.notify = notify();
      $(document).on('show.bs.modal', '#app-bar-more', () => {
        $('#app-bar').addClass('more-active');
      });
      $(document).on('hide.bs.modal', '#app-bar-more', (e) => {
        try {
          $('#app-bar').removeClass('more-active');
          this.moreActiveMobile = false;
          if ($('#app-bar').length) {
            $('#app-bar').find('li').removeClass('is-active');
          }
          $('#app-bar').find('li').eq(this.selectedIdx).addClass('is-active');
        } catch (error) {
        }
      });
    }, 1000);
    
  }

  activateMore(x: string): void {
    if (x === 'desktop') {
      this.moreActiveDesktop = !this.moreActiveDesktop;
      if (this.moreActiveDesktop) {
        this.selectedDesktopIdx = $('#app-bar-desktop').find('li.is-active').index();
        $('#app-bar-desktop').find('li').eq(this.selectedDesktopIdx).removeClass('is-active');
      }
      else $('#app-bar-desktop').find('li').eq(this.selectedDesktopIdx).addClass('is-active');
    }
    else {
      this.moreActiveMobile = !this.moreActiveMobile;
      this.selectedIdx = $('#app-bar').find('li.is-active').index();
      $('#app-bar').addClass('more-active');
      if (this.moreActiveMobile) {
        $('#app-bar').find('li').eq(this.selectedIdx).removeClass('is-active');
      }

    }

  }

  startSOSFlow(): void {
    this.claimStore.reset();
    // no policy context here, so the claimant is the logged-in user. Without an
    // explicit person_id the guard checks person_id 0 and never fires.
    this.claimGuardService.startClaimFlow(null, 0, 0, 0, this.currentUser?.person_id)
      .subscribe((result: any) => {
        if (!result) {
          return;
        }
        if (result[0]?.next_superflow) {
          setTimeout(() => {
              const sessionDetails = this.questionFlowSessionQuery.getValue();
              if (sessionDetails?.session_id) {
                this.questionService.saveAnswer(sessionDetails.session_id, 1073, 0, '0', '8', 0, '').subscribe();
              }
          }, 3000);
          this.flowPlayer.startSuperFlow(result[0]?.next_superflow, 0, 0, 0, '0', '', '');
        }

      });
  }
  setDetail(value): void{
    this.detailsShown.emit(value);
  }
  comingSoon(): void {
    const date = new Date();
    const id = date.getTime().toString();
    // console.log(id)
    // try { this.notify.clear(); } catch (e) { }
    this.notify.init({
      message: '<strong>Coming Soon! &#128522;</strong>', // required
      icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
      size: 'lg',     // default: null; options: 'lg'
      style: 'info',  // default: null; options: 'info', 'success',
      close: true,    // default: false (close button enabled, auto-close duration removed)
      speed: 350,
      autoClose: true,   // default: 350 (fade in/out speed)
      duration: 5000,  // default: 5000 (duration active)
      static: null
    }, id);
  }
  requestCall(): void {
    this.requestCallComponent.showModal(this.currentUser);
    $('#app-bar').removeClass('more-active');
  }

}
